import React, { FC } from 'react';
import styled from '@emotion/styled';
import Loader from '~ComponentsImproved/Loader';

/**
 * Shown for the brief moment before the venue theme has arrived, so the themed
 * loader below never has to flash the default palette first.
 */
const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--eposPrimary);
`;

const BootSpinner: FC = () => (
  <Wrapper>
    <Loader color="var(--eposAccent)" />
  </Wrapper>
);

export default BootSpinner;
